import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'

export function getPathWithLocalePrefix(path: string, locale: LocaleType): string {
  if(locale === LocaleType.English) {
    return path
  }
  return path === '/' ? `/${locale}` : `/${locale}${path}`
}
